module.exports = __webpack_public_path__ + "static/media/goilogo1.ac24d739.png";